import { map, filter } from 'lodash/fp';
import { createSelector } from 'reselect';
import { getStringProp } from '@mews/fp';
import { createAction } from '@mews/framework';
import { ApplicationState } from '@mews-commander/types';
import { EnterpriseProfileRoleAssignment } from '@mews-commander/data-access';
import parentSelector from '../selector';
import prefix from '../prefix';
import { createScopedEntitiesReducer, createScopedBaseEntitySelectors } from './utils';

export const NAME = 'enterpriseProfileRolesAssignments';

const ENTERPRISE_PROFILE_ROLE_ASSIGNMENTS_UPDATED = prefix('ENTERPRISE_PROFILE_ROLE_ASSIGNMENTS_UPDATED');
const ENTERPRISE_PROFILE_ROLE_ASSIGNMENTS_DELETED = prefix('ENTERPRISE_PROFILE_ROLE_ASSIGNMENTS_DELETED');

export const [getRoleAssignments] = createScopedBaseEntitySelectors<
    ApplicationState,
    EnterpriseProfileRoleAssignment,
    typeof NAME,
    'enterpriseId'
>(parentSelector, NAME, 'enterpriseId');

export const setEnterpriseProfileRoleAssignments = (entities: EnterpriseProfileRoleAssignment[], scope: string) =>
    createAction(ENTERPRISE_PROFILE_ROLE_ASSIGNMENTS_UPDATED, entities, { scope });

export const deleteEnterpriseProfileRoleAssignments = (ids: string[], scope: string) =>
    createAction(ENTERPRISE_PROFILE_ROLE_ASSIGNMENTS_DELETED, ids, { scope });

export const enterpriseProfileRolesAssignmentsReducer = createScopedEntitiesReducer({
    UPDATE_SUCCESS: ENTERPRISE_PROFILE_ROLE_ASSIGNMENTS_UPDATED,
    DELETE_SUCCESS: ENTERPRISE_PROFILE_ROLE_ASSIGNMENTS_DELETED,
});

export const getEnterpriseProfileRoleAssignments = createSelector(
    getRoleAssignments,
    getStringProp('enterpriseProfileId'),
    (rolesAssignments, profileId) => filter<EnterpriseProfileRoleAssignment>({ profileId })(rolesAssignments)
);

export const getEnterpriseProfileRoleAssignmentIds = createSelector(getEnterpriseProfileRoleAssignments, map('id'));

export const getEnterpriseProfileRoleIds = createSelector(getEnterpriseProfileRoleAssignments, map('roleId'));
